import { FaLinkedin, FaGithub, FaOrcid, FaEnvelope } from "react-icons/fa6";
import { Downloads } from "./Downloads";

export function Intro() {
  return (
    <div className="lg:fixed flex flex-col lg:min-h-[50vw]">
      <h1 className="text-4xl lg:text-5xl font-bold">James Borgars</h1>
      <h3 className="text-xl lg:text-2xl mt-2">Software Engineer</h3>
      <p className="mt-2 lg:text-xl text-slate-400">Writing code since 2013.</p>

      <div className="mt-4 lg:mt-10">
        <Downloads />
      </div>

      <div className="mt-6 lg:mt-auto space-x-8 lg:space-x-16 text-3xl lg:text-5xl text-slate-400 flex flex-cols-4 justify-center lg:justify-left">
        <a
          href="https://linkedin.com/in/james-borgars"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-slate-200"
        >
          <FaLinkedin />
        </a>

        <a
          href="https://github.com/Borgars"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-slate-200"
        >
          <FaGithub />
        </a>

        <a
          href="https://orcid.org/0009-0001-6689-6802"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-slate-200"
        >
          <FaOrcid />
        </a>

        <a
          href="mailto:james@borga.rs"
          target="_blank"
          rel="noopener norferrer"
          className="hover:text-slate-200"
        >
          <FaEnvelope />
        </a>
      </div>
    </div>
  );
}
